import ETextInput from '@/components/everridge/ETextInput';
import InformationIconSolid from '@/components/icons/InformationIconSolid';
import { FC } from 'react';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SettingsFormData } from '@/features/settings/SettingsPage';
import { cn } from '@/lib/utils';
import EToogler from '@/components/everridge/EToogler';

type Props = {
    control: Control<SettingsFormData>;
    isMobile?: boolean;
};

const SettingsBillingDetails: FC<Props> = ({ control, isMobile }) => {
    const { t } = useTranslation();

    return (
        <div
            className={cn(
                'w-full p-6 flex flex-col gap-4 border border-popover-100 rounded-2.5xl bg-popover-10',
                isMobile && 'w-full p-0 border-0 bg-popover-30',
            )}
        >
            <h3 className={cn(isMobile && 'text-base')}>
                {t('main.settings.components.bank.title')}
            </h3>
            <ETextInput
                control={control}
                fieldName={'bankName'}
                label={t('elements.form.bank.label')}
                placeholder={t('elements.form.bank.placeholder')}
            />
            <div className={cn('flex gap-4', isMobile && 'flex-col')}>
                <ETextInput
                    control={control}
                    fieldName={'swiftCode'}
                    label={t('elements.form.swift.label')}
                    placeholder={t('elements.form.swift.placeholder')}
                />
                <ETextInput
                    control={control}
                    fieldName={'iban'}
                    label={t('elements.form.iban.label')}
                    placeholder={t('elements.form.iban.placeholder')}
                />
            </div>
            <EToogler
                control={control}
                fieldName={'multiCurrency'}
                label={t('elements.form.multiCurrency.label')}
                placeholder={t('elements.form.multiCurrency.placeholder')}
				text={t('main.settings.form.multiCurrency.text')}
            />
            <div className="p-3.5 flex gap-2 border border-popover-100 rounded-semi-xl bg-popover-10">
                <InformationIconSolid className="size-4 shrink-0" />
                <p className="text-xs font-medium text-popover-800">
                    {t('main.settings.components.bank.text')}
                </p>
            </div>
        </div>
    );
};

export default SettingsBillingDetails;
